import React from 'react';
import styled from 'styled-components';
import { Box } from '../../../Box/Box';

export const StyledToggle = styled.label({
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  position: 'relative',
  verticalAlign: 'bottom',
});

export const Icons = styled.div<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 1,
  color: theme.colors.bg,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',

  '&::before, &::after': {
    position: 'absolute',
    fontFamily: "'Font Awesome 5 Pro'",
    fontWeight: 900,
    transition: 'opacity 0.3s ease',
    fontSize: theme.fontSizes.extraSmall,
  },

  '&::before': {
    left: 5,
    content: "'\f00c'",
    opacity: isSelected ? 1 : 0,
  },

  '&::after': {
    right: 5,
    content: "'\f00d'",
    opacity: isSelected ? 0 : 1,
  },
}));

export const Switch = styled.span<{ isSelected: boolean }>(({ theme, isSelected }) => ({
  display: 'inline-block',
  borderRadius: 16,
  position: 'relative',
  transition: 'all 0.2s ease',
  width: 32,
  height: 16,
  background: isSelected ? theme.colors.primary[500] : theme.colors.neutral[500],

  '&:after': {
    content: '""',
    position: 'absolute',
    borderRadius: '100%',
    top: '50%',
    left: isSelected ? '75%' : '25%',
    background: theme.colors.bg,
    transform: 'translate(-50%, -50%)',
    transition: 'all 0.2s ease',
    zIndex: 1,
    width: 12,
    height: 12,
  },
}));

interface ToggleProps {
  isSelected: boolean;
}

export const Toggle: React.FC<ToggleProps> = ({ isSelected }) => {
  return (
    <Box display="flex" alignItems="center" p="2">
      <StyledToggle>
        <Icons isSelected={isSelected} />

        <Switch isSelected={isSelected} />
      </StyledToggle>
    </Box>
  );
};
